function formatIsoDateLocal(d) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
export function validateCashCustomPeriod(dateFrom, dateTo) {
    if (!dateFrom.trim())
        return 'From date is required.';
    if (!dateTo.trim())
        return 'To date is required.';
    if (dateFrom > dateTo)
        return 'From must be on or before To.';
    return null;
}
/** Resolve calendar date range from period preset or custom inputs. */
export function resolveCashPeriodDateRange(period, dateFrom, dateTo) {
    const now = new Date();
    if (period === 'today') {
        const t = formatIsoDateLocal(now);
        return { dateFrom: t, dateTo: t };
    }
    if (period === '7d') {
        const from = new Date(now);
        from.setDate(from.getDate() - 6);
        return { dateFrom: formatIsoDateLocal(from), dateTo: formatIsoDateLocal(now) };
    }
    if (period === '30d') {
        const from = new Date(now);
        from.setDate(from.getDate() - 29);
        return { dateFrom: formatIsoDateLocal(from), dateTo: formatIsoDateLocal(now) };
    }
    return { dateFrom: dateFrom.trim(), dateTo: dateTo.trim() };
}
